module.exports = __webpack_public_path__ + "static/media/Mapa-Paraná.c3a2eab5.svg";